export const LOGIN = '/login';
export const PASSWORD_RECOVERY = '/password-recovery';
export const HOME = '/';
export const AUTO_LOGIN = '/auto-login';

// auto-login?operator-auto-login-info=alexeykol|operator1|7c6a180b36896a0a8c02787eeafb0e4c|false
